module.exports = __webpack_public_path__ + "static/media/orbit-seasons-3.png";